<app-nav-bar [userName]="userName"></app-nav-bar>
<div class="body-container">
<router-outlet></router-outlet>
</div>
